if (!customElements.get('carousel-navigation')) {
  customElements.define(
    'carousel-navigation',
    class CarouselNavigation extends HTMLElement {
      constructor() {
        super();

        const slideContent = this.closest('.slide');
        this.buttons = this.querySelectorAll('button');
        this.slideshowControls = slideContent.querySelector('.products-card-slider');

        this.buttons.forEach(btn => {
          btn.addEventListener('click', () => {
            console.log(btn.closest('.slide'));
            btn.closest('.slide').querySelector('.slide-content').classList.remove('default-content__active');
            btn.closest('.hero-product-slider').classList.add('no-default-content');
            slideContent.querySelectorAll('slideshow-slide').forEach(slide => {
              slide.setAttribute('aria-hidden', 'false');
            });
            
            const index = btn.dataset.index;

            if (!slideContent) return;

            const target = slideContent.querySelector(
              `.products-card-slider .slideshow-controls__dots button[data-index="${index}"]`
            );

            if (target) target.click();

            // Set aria-current="true" on clicked button
            btn.setAttribute("aria-current", "true");

            // Remove aria-current from all other buttons
            this.buttons.forEach(other => {
              if (other !== btn) {
                other.setAttribute("aria-current", "false");
              }
            });

          });
        });

        this.slideshowControls.addEventListener('click', (e) => {
          // console.log(e.currentTarget);
          const index = e.currentTarget.querySelector('[aria-selected="true"]').dataset.index;
          const target = this.querySelector(
            `button[data-index="${index}"]`
          );
          console.log(target);

          // Remove aria-current from all other buttons
          this.buttons.forEach(other => {
            other.setAttribute("aria-current", "false");
          });

          // Set aria-current="true" on clicked button
          target.setAttribute("aria-current", "true");
        });
      }
    }
  );
}
